import React from "react";
import { JobStatusEnum } from "@/lib/types/job";
import { Archive, CheckCircle, CircleDashed, Clock } from "lucide-react";

const STATUS_TEXT_COLORS: Record<number, string> = {
	[JobStatusEnum.REQUESTED]: "text-gray-400",
	// [JobStatusEnum.PRE_REGISTERED]: "text-orange-500",
	[JobStatusEnum.IN_PROGRESS]: "text-blue-500",
	[JobStatusEnum.COMPLETED]: "text-emerald-500",
	[JobStatusEnum.ARCHIVED]: "text-red-500",
	[JobStatusEnum.BOOKED_SINGLE]: "text-amber-500",
	[JobStatusEnum.BOOKED_MONTHLY]: "text-amber-500",
	[JobStatusEnum.PAID_SINGLE]: "text-slate-400",
	[JobStatusEnum.PAID_MONTHLY]: "text-slate-400",
};

const STATUS_BG_COLORS: Record<number, string> = {
	[JobStatusEnum.REQUESTED]: "bg-gray-400",
	// [JobStatusEnum.PRE_REGISTERED]: "bg-orange-500",
	[JobStatusEnum.IN_PROGRESS]: "bg-blue-500",
	[JobStatusEnum.COMPLETED]: "bg-emerald-500",
	[JobStatusEnum.ARCHIVED]: "bg-red-500",
	[JobStatusEnum.BOOKED_SINGLE]: "bg-amber-500",
	[JobStatusEnum.BOOKED_MONTHLY]: "bg-amber-500",
	[JobStatusEnum.PAID_SINGLE]: "bg-slate-400",
	[JobStatusEnum.PAID_MONTHLY]: "bg-slate-400",
};

export const getStatusColor = (status: JobStatusEnum): string => {
	return STATUS_TEXT_COLORS[status] ?? "text-neutral-500";
};

export const getStatusBgColor = (status: number): string => {
	return STATUS_BG_COLORS[status] ?? "bg-gray-300";
};

export const getStatusIcon = (status: JobStatusEnum) => {
	switch (status) {
		case JobStatusEnum.REQUESTED:
			return <CircleDashed className="h-3 w-3" />;
		case JobStatusEnum.IN_PROGRESS:
			return <Clock className="h-3 w-3" />;
		case JobStatusEnum.COMPLETED:
			return <CheckCircle className="h-3 w-3" />;
		case JobStatusEnum.ARCHIVED:
			return <Archive className="h-3 w-3" />;
		default:
			return <CircleDashed className="h-3 w-3" />;
	}
};
